import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Hand14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M5.75 0.25C4.64543 0.25 3.75 1.14543 3.75 2.25V7.25H3.5C2.25736 7.25 1.25 8.25736 1.25 9.5V13H2.75L2.75 9.5C2.75 9.08579 3.08579 8.75 3.5 8.75H3.75V11H5.25V2.25C5.25 1.97386 5.47386 1.75 5.75 1.75C6.02614 1.75 6.25 1.97386 6.25 2.25V9H7.75V6.75H8.75V9H10.25V6.75H10.5C10.9142 6.75 11.25 7.08579 11.25 7.5V13H12.75V7.5C12.75 6.25736 11.7426 5.25 10.5 5.25H7.75V2.25C7.75 1.14543 6.85457 0.25 5.75 0.25Z'
      fill='currentColor'
    />
  </Svg>
);

Hand14.displayName = 'Hand14';
export default Hand14;
